import { fromDate, ZonedDateTime } from '@internationalized/date';
import { atom } from 'jotai';

export const histogramVisibleTimeRangeAtom = atom<
  [ZonedDateTime, ZonedDateTime]
>([fromDate(new Date(), 'UTC'), fromDate(new Date(), 'UTC')]);

export const histogramTimelineDragOffsetAtom = atom<number>(0);
